import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownBar() {
  const {
    minutes,
    seconds,
    isExpired
  } = useCountdown(14, 50);
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white py-1.5 px-4 text-center shadow-md" data-id="element-77">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-xs sm:text-sm font-bold" data-id="element-78">
        {isExpired ? <span className="text-white animate-pulse" data-id="element-79">
            🔥 OFERTA EXPIRADA 🔥
          </span> : <>
            <span className="text-white" data-id="element-80">⏳ OFERTA EXPIRA EN:</span>
            <span className="bg-white text-red-600 px-2 py-0.5 rounded font-mono text-xs sm:text-sm font-black tracking-wider" data-id="element-81">
              {minutes}:{seconds}
            </span>
            <span className="text-red-200 hidden sm:inline" data-id="element-82">|</span>
            <span className="text-white hidden sm:inline" data-id="element-83">
              🔥 CUPOS LIMITADOS HOY
            </span>
          </>}
      </div>
    </div>;
}